import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import { pluginPath } from '../../constants/leadinConfig';
import UIImage from '../UIComponents/UIImage';
export default function MeetingGutenbergPreview() {
    return (_jsx(Fragment, { children: _jsx(UIImage, { alt: "Create a new Hubspot Meeting", width: "100%", src: `${pluginPath}/public/assets/images/hubspot-meetings.png` }) }));
}
